<mat-card>
  <mat-card-header class="widget-header" *ngIf="!widget.meta.hideTitle">
    <mat-card-title
      *ngIf="!changeTitle; else editTitleWidget"
      [matTooltip]="'dashboard.operational.widgets.doubleClickToEditTitle' | t"
      matTooltipPosition="above"
      (dblclick)="editTitle()"
      class="editTitle"
      >{{ widget.name }}
      <sn-icon size="xs">edit</sn-icon>
    </mat-card-title>
  </mat-card-header>

  <sn-google-map zoom="8" [center]="googleMapCenter" (mapInit)="onMapInit($event)">
    <div class="map__style map__control-group">
      <sn-icon-button
        type="button"
        (click)="zoomIn()"
        color="accent"
        [matTooltip]="'common.zoomIn' | t"
        matTooltipPosition="left"
      >
        <sn-icon fontSet="fal" fontIcon="fa-plus"></sn-icon>
      </sn-icon-button>
      <sn-icon-button
        type="button"
        color="accent"
        (click)="zoomOut()"
        [matTooltip]="'common.zoomOut' | t"
        matTooltipPosition="left"
      >
        <sn-icon fontSet="fal" fontIcon="fa-minus"></sn-icon>
      </sn-icon-button>
    </div>
  </sn-google-map>

  <mat-list>
    <mat-list-item *ngFor="let layer of layers">
      <span mat-line matListItemTitle>{{ layer.layer.layers?.name }}</span>
      <button mat-icon-button (click)="updateDateRange(layer.layer)">
        <sn-icon fontSet="fal" fontIcon="fa-calendar"></sn-icon>
      </button>
      <ng-container *ngIf="layer.layer.layers?.layer_active">
        <sn-icon-button (click)="toggleLayer(layer)">
          <sn-icon
            fontSet="fal"
            fontIcon="fa-eye"
            [matTooltip]="'common.hideLayer' | t"
            matTooltipPosition="left"
          >
          </sn-icon>
        </sn-icon-button>
      </ng-container>
      <ng-container *ngIf="!layer.layer.layers?.layer_active">
        <sn-icon-button (click)="toggleLayer(layer)">
          <sn-icon
            fontSet="fal"
            fontIcon="fa-eye-slash"
            [matTooltip]="'common.showLayer' | t"
            matTooltipPosition="left"
          >
          </sn-icon>
        </sn-icon-button>
      </ng-container>
      <ng-container *ngFor="let color of layer.layer.layers?.colors">
        <div
          class="colorMarker"
          [ngStyle]="{ 'background-color': convertToRGB(color[0], color[1], color[2]) }"
        ></div>
      </ng-container>
      <mat-divider [inset]="true"></mat-divider>
    </mat-list-item>
    <mat-divider></mat-divider>
  </mat-list>
</mat-card>

<ng-template #editTitleWidget>
  <sn-form-edit-title
    [widget]="widget"
    [viewId]="viewId"
    (title)="setTitle($event)"
    (updateTitle)="setUpdateTitle($event)"
  ></sn-form-edit-title>
</ng-template>
